import { render } from "./CrimesView.vue?vue&type=template&id=44e18404&scoped=true"
import script from "./CrimesView.vue?vue&type=script&lang=js"
export * from "./CrimesView.vue?vue&type=script&lang=js"

import "./CrimesView.vue?vue&type=style&index=0&id=44e18404&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44e18404"]])

export default __exports__